module.exports = __webpack_public_path__ + "19116d4e3563a0419a86597f81ae7ba8.svg";